import React, { useEffect } from "react"
import TopBar from "./tobBar"
import SideBar from "./sideBar"
import Footer from "./footer"
import "../assets/css/portal.css"
import "../assets/js/app.js"
import { useNavigate } from "react-router-dom"
import { myroutes } from "../../routes/webroute"
//import { authCheck } from "../../services/http"

export default function Layout({ children }) {
    const navigate = useNavigate()

    useEffect(() => {
        /*if (authCheck().valueOf() === false) {
            //deconnecter l'utilisateur et renvoie sur login page
            localStorage.removeItem("token")
            localStorage.removeItem("user")
            localStorage.removeItem("roles")
            navigate(myroutes.login)
        }*/
    }, [navigate])

    return (
        <React.Fragment>
            <header className="app-header fixed-top">
                <TopBar />
                <SideBar />
            </header>
            <div className="app-wrapper pt-5" style={{ background: "#e7e9ed" }}>
                {children}
                <Footer />
            </div>
        </React.Fragment>
    )
}